import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  gallerySectionMainBox: {
    padding: 80,
    backgroundColor:theme.palette.secondary.main,
    [theme.breakpoints.only("xs")]:{
      paddingTop: 40,
      paddingBottom: 40,
      paddingLeft: 20,
      paddingRight: 20,
    }
  },
  gallerySectionTitle: {
    fontWeight: 500,
    color: theme.palette.common.white,
    marginBottom: 60,
    [theme.breakpoints.only("xs")]: {
      fontWeight: 900,
      marginBottom: 40,
    },
  },
  introContent: {
    width: "85%",
    marginBottom: 20,
  },
}));

export default useStyles;
